import React from 'react'
import { Container, Row, Col } from "react-bootstrap";

const ServicesBanner = () => {
    return (
        <div>
            <video
                className="banner-wrapper"
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                disablePictureInPicture
                controlsList="nodownload noplaybackrate nofullscreen"
                style={{height: '280px'}}
            >
                <source 
                    src={require('../../../assets/videos/headervideo/header-video.mp4')} 
                    type="video/mp4"
                />
            </video>
      
            <div className="gradient-overlay">
                <Container className="py-5" >
                    <Row className="d-flex align-items-center justify-content-center">
                        <Col xxl={8} xl={8} lg={8} md={10} sm={10} xs={10} className="text-center">
                            <p className="fs-28 fw-400 sub-header text-black mb-1">
                                Policy
                            </p>
                            <p className='fw-400 header'>
                                Services  
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default ServicesBanner
